<template>
  <div class="footer">
    <div class="whiteLogo_box">
      <img class="whiteLogo" src="@/assets/mobile/logo.png" alt="" />
    </div>
    <div class="navList">
      <div @click="$router.push('/mobileHome')"><span>首页</span></div>
      <div @click="$router.push('/mobileNews')">
        <span>公司动态</span>
      </div>
      <!-- <div @click="goToWebsite">
        <span>米啦产品</span>
      </div> -->
      <!-- <div @click="$router.push('/mobileGaokao')">
        <span>日语高考</span>
      </div> -->
      <div @click="$router.push('/mobileContact')">
        <span>联系我们</span>
      </div>
    </div>
    <div class="code">
      <div class="codeItem">
        <img src="@/assets/mobile/principal.png" alt="" />
        <div class="mg10">商务合作</div>
        <div class="mg10">请扫码联系我们</div>
      </div>
      <div class="codeItem">
        <img src="@/assets/mobile/Official.png" alt="" />
        <div class="mg10">公众号</div>
        <div class="mg10">扫码关注最新资讯</div>
      </div>
    </div>
    <div class="txt">
      <div>
        Copyright ©
        {{
          new Date().getFullYear() == "2025" ? "2025" : `2025-${new Date().getFullYear()}`
        }}
        | 湖南米啦科技有限公司版权所有 |<br />
        <a href="http://beian.miit.gov.cn">备案号：湘ICP备2025115029号-2</a>
      </div>
      <div>
        公司地址:湖南省长沙市岳麓区天顶街道环湖路 1177号方茂苑（二期）12、13、15栋1916室
        |<br />
        联系方式：guohao@hskgoo.com
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToWebsite() {
      window.open("https://api.juquedu.com/website/index.html");
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  // height: 664px;
  background-color: #3a3636;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  color: #c5c5c5;
  font-size: 15px;
  .whiteLogo_box {
    padding: 32px 0 0 15px;
    .whiteLogo {
      width: 36px;
      border-radius: 8px;
    }
  }
  .navList {
    margin-top: 40px;
    div {
      display: flex;
      align-items: center;
      height: 51px;
      border-bottom: 1px solid #575353;
      span {
        margin-left: 15px;
      }
    }
    div:active {
      background: #575353;
    }
  }
  .mg10 {
    margin-top: 10px;
  }
  .code {
    display: flex;
    justify-content: space-around;
    text-align: center;
    .codeItem {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 130px;
      margin-top: 36px;
    }
    img {
      width: 100px;
    }
  }
  .txt {
    padding-bottom: 40px;
    font-size: 12px;
    margin: 18px 15px 0 15px;
    text-align: center;
    a {
      color: #afa6a6;
    }
  }
}
</style>
